import { trustBadges } from '../../../mocks/home';

const TrustBar = () => {
  return (
    <section className="bg-navy border-y border-teal/20 py-5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between gap-4 overflow-x-auto scrollbar-hide">
          {trustBadges.map((badge, index) => (
            <div
              key={index}
              className="flex items-center gap-2.5 shrink-0 px-4 py-2.5 rounded-lg hover:bg-teal/10 transition-colors duration-200 group"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-teal/15 rounded-lg group-hover:bg-teal/25 transition-colors">
                <i className={`${badge.icon} text-teal text-sm`}></i>
              </div>
              <div>
                <div className="text-white font-heading font-700 text-xs whitespace-nowrap leading-tight">{badge.label}</div>
                <div className="text-teal/70 font-body text-xs whitespace-nowrap leading-tight">{badge.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
